import { NextPage } from "next";
import Layout from "../components/layout";
import { AppSettings } from "../lib/get-app-settings";
import styles from "../styles/error-page.module.css";
import ErrorMessage from "../components/error-message";
import useAppSettings from "../lib/use-app-settings";

type NotFoundPageProps = {
  appSettings?: AppSettings;
};

const NotFoundPage: NextPage<NotFoundPageProps> = ({ appSettings }) => {
  const [settings, pending] = useAppSettings(appSettings);

  const className = pending ? styles.pending : undefined;

  const title = "404";
  const error = "The page you are looking for does not exist.";

  if (!settings)
    return (
      <ErrorMessage className={className} title={title}>
        {error}
      </ErrorMessage>
    );

  return (
    <Layout appSettings={settings} hasTitle className={styles.lazyAppearance}>
      <ErrorMessage title={title}>{error}</ErrorMessage>
    </Layout>
  );
};

export default NotFoundPage;
